import { render, staticRenderFns } from "./AssociateDetail.vue?vue&type=template&id=73cb6dd7&"
import script from "./AssociateDetail.vue?vue&type=script&lang=js&"
export * from "./AssociateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports